import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { lazy, memo } from 'react'

const TeacherHeader = lazy(() =>
    import('./TeacherHeader').then((m) => ({ default: m.default }))
)
const SchoolHeader = lazy(() =>
    import('./SchoolHeader').then((m) => ({ default: m.default }))
)
const CentreHeader = lazy(() =>
    import('./CentreHeader').then((m) => ({ default: m.default }))
)
const FallbackHeader = lazy(() =>
    import('./components/FallbackHeader').then((m) => ({ default: m.default }))
)

const DashboardHeader = () => {
    const accountType = useSelector(
        (state: RootState) => state.user.user.data?.accountType
    )

    switch (accountType) {
        case 'teacher':
            return <TeacherHeader />
        case 'school':
            return <SchoolHeader />
        case 'childcareCentre':
            return <CentreHeader />
        default:
            return <FallbackHeader />
    }
}

export default memo(DashboardHeader)
